import type {
	IProductInfoConstructorParams,
	ProductInfoAction,
	ProductInfoSecondaryAction,
} from "@services/sdk/interfaces";

class ProductInfo {
	public static Construct(params: IProductInfoConstructorParams): ProductInfo {
		return new ProductInfo(params);
	}

	responseData: IProductInfoConstructorParams;

	constructor(params: IProductInfoConstructorParams) {
		this.responseData = params;
	}

	get theme(): string {
		return this.responseData.theme;
	}

	get iconRef(): string {
		return this.responseData.iconRef;
	}

	get title(): string {
		return this.responseData.title;
	}

	get text(): string {
		return this.responseData.text;
	}

	get actions(): Array<ProductInfoAction> | null {
		if (!this.responseData.actions) return null;

		return this.responseData.actions.map((a) => {
			return {
				label: a.label,
				type: a.type,
				value: a.value,
			};
		});
	}

	get primaryButton(): string {
		return this.responseData.primaryButton;
	}

	get secondaryButton(): string {
		return this.responseData.secondaryButton;
	}

	get secondaryAction(): ProductInfoSecondaryAction | null {
		if (!this.responseData.secondaryAction) return null;

		return {
			type: this.responseData.secondaryAction.type,
			value: this.responseData.secondaryAction.value,
		};
	}
}

export default ProductInfo;
